import { Result, ok, err } from '../../../tracking-api';
import { Scorm2004Api } from '../api';
import { Scorm2004ApiResolver } from './scorm2004-api-resolver';
import { APIFinder } from './api-finder';

export class RemoteScorm2004ApiResolver implements Scorm2004ApiResolver {

  constructor(private apiFinder: APIFinder) {
  }

  public resolve(): Result<Scorm2004Api, false> {
    const api = this.apiFinder.find(window);
    if (api === null) {
      return err(false);
    }

    return ok(api as Scorm2004Api);
  }
}
